// do not change the lowercase names, they are used for routing
export enum AuctionStatus {
  Available = 'available',
  Completed = 'completed',
  Dutch = 'dutch',
  Live = 'live',
  Minted = 'minted',
  Unknown = 'unknown',
  Upcoming = 'upcoming',
}
